import { render, staticRenderFns } from "./General.vue?vue&type=template&id=b9f0d744&"
import script from "./General.vue?vue&type=script&lang=js&"
export * from "./General.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/faq-general.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2F_work%2Facces-impot%2Facces-impot%2Flegacy%2Fpackages%2Facces-impot-front%2Fpages%2FFaq%2FGeneral.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports